export const INIT_FILTER_VALUE = {
  created_at: {
    date_end: "",
    date_start: "",
  },
  range: {
    date_end: "",
    date_start: "",
  },
  full_budget: {
    start: "",
    end: "",
  },
  daily_budget: {
    start: "",
    end: "",
  },
  decrease: {
    start: "",
    end: "",
  },
  type: "",
  status: "",
  site: "",
  campaign_creator_email: "",
  id: "",
  name: "",
  bet: {
    start: "",
    end: "",
  },
  sort: "created_at",
};

export const cloneCampaignFilters = (filters) => ({
  ...filters,
  created_at: { ...filters.created_at },
  range: { ...filters.range },
  full_budget: { ...filters.full_budget },
  daily_budget: { ...filters.daily_budget },
  decrease: { ...filters.decrease },
  bet: { ...filters.bet },
});

export const filterDate = (oDate, arr) => {
  const tempDate = {
    date_end: oDate.date_end || new Date(3000, 10, 10),
    date_start: oDate.date_start || new Date(3, 10, 10),
  };
  return arr.filter((item) => {
    if (!oDate.date_start && !oDate.date_end) return true;
    const date = new Date(item?.created_at);
    return tempDate.date_start <= date && tempDate.date_end >= date;
  });
};

export const sortCampaings = (type, arr) => {
  switch (type) {
    case "created_at":
      return [...arr].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    case "created_at asc":
      return [...arr].sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
    default:
      return arr;
  }
};
